import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
    const [email, setEmail] = useState('');

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    const mailtoLink = `mailto:info@northernprokitchen.com?subject=Newsletter%20Subscription&body=I%20would%20like%20to%20connect.%20My%20email%20is:%20${encodeURIComponent(email)}`;

    return (
        <>
            <div className='flex flex-col sm:flex-row justify-between px-6 sm:px-20 py-10 sm:py-20'>
                {/* Address and Branding */}
                <div className='flex flex-col gap-4'>
                    <div className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-2 text-sm">
                        <p className="font-semibold text-indigo-900 text-right">EMAIL:</p>
                        <p className="text-gray-600 text-start">info@northernprokitchen.com</p>

                        <p className="font-semibold text-indigo-900 text-right">PHONE:</p>
                        <p className="text-gray-600 text-start">+971 2586 8431</p>

                        <p className="font-semibold text-indigo-900 text-right">ADDRESS:</p>
                        <p className="text-gray-600 text-start">
                            MW5 - Mussafah industrial city <br />
                            Abu Dhabi - UAE
                        </p>
                    </div>

                    <div className="logo md:w-60 md:h-20 w-36 h-12">
                        <img src="/assets/NORTHERN_PROFESSIONAL_LOGO.png" alt="logo" className='w-full h-full' />
                    </div>
                </div>

                {/* Newsletter and Social Media */}
                <div className='flex flex-col items-start sm:items-end gap-6 mt-8 sm:mt-0'>
                    <div className='flex flex-col gap-3 w-full sm:w-auto'>
                        <p className="text-sm font-semibold text-left text-indigo-900">Connect With Us:</p>
                        <div className="flex flex-col sm:flex-row gap-3">
                            <input
                                type="email"
                                placeholder="Your email here"
                                value={email}
                                onChange={handleEmailChange}
                                className="flex-1 px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 w-full sm:w-auto"
                            />
                            <Link
                                to={mailtoLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="px-4 py-2 bg-orange-500 text-white rounded hover:bg-orange-600 w-full sm:w-auto text-center"
                            >
                                Connect
                            </Link>
                        </div>
                    </div>

                    {/* Social Media Icons */}
                    <div className="flex gap-4 justify-start w-full">
                        <Link
                            to="https://wa.me/971569186717"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-8 h-8 bg-gray-800 text-white rounded-full flex items-center justify-center hover:bg-indigo-900 cursor-pointer"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="icon icon-tabler icons-tabler-outline icon-tabler-brand-whatsapp"
                            >
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M3 21l1.65 -3.8a9 9 0 1 1 3.4 2.9l-5.05 .9" />
                                <path d="M9 10a.5 .5 0 0 0 1 0v-1a.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a.5 .5 0 0 0 0 -1h-1a.5 .5 0 0 0 0 1" />
                            </svg>
                        </Link>
                        <Link
                            to="https://www.linkedin.com/company/northern-professional-kitchen-equipment/about/?viewAsMember=true"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-8 h-8 bg-gray-800 text-white rounded-full flex items-center justify-center hover:bg-indigo-900 cursor-pointer"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-brand-linkedin"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M8 11v5" /><path d="M8 8v.01" /><path d="M12 16v-5" /><path d="M16 16v-3a2 2 0 1 0 -4 0" /><path d="M3 7a4 4 0 0 1 4 -4h10a4 4 0 0 1 4 4v10a4 4 0 0 1 -4 4h-10a4 4 0 0 1 -4 -4z" /></svg>
                        </Link>
                        <Link
                            to="https://www.facebook.com/profile.php?id=61577075877482"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-8 h-8 bg-gray-800 text-white rounded-full flex items-center justify-center hover:bg-indigo-900 cursor-pointer"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-brand-facebook"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3" /></svg>
                        </Link>
                        <Link
                            to="https://www.instagram.com/northern_professional_kitchen?igsh=cW11MmkzNmIzcnUw&utm_source=qr"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-8 h-8 bg-gray-800 text-white rounded-full flex items-center justify-center hover:bg-indigo-900 cursor-pointer"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-brand-instagram"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M4 8a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z" /><path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" /><path d="M16.5 7.5v.01" /></svg>
                        </Link>
                    </div>
                    {/* ISO-ICV Image */}
                    <div className="flex w-full justify-start mt-2">
                        <img src="/assets/ISO-ICV.png" alt="ISO ICV Certification" className="h-20 sm:h-24 object-contain" />
                    </div>
                </div>
            </div>

            {/* Footer Bottom */}
            <div className='h-14 bg-indigo-900 text-gray-300 px-6 sm:px-20 text-center sm:text-start flex items-center justify-center sm:justify-start text-xs sm:text-base'>
                NorthernProfessional Company © {new Date().getFullYear()}. All Rights Reserved
            </div>
        </>
    );
}